var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{staticClass:"gba_pop",attrs:{"closeable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"gba_wrap"},[_c('img',{attrs:{"src":require("@/assets/img/live/live-gba.jpg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }